import { APP, WS_DATA } from './app.constants';

export const BEACONS = `${APP}_beacons`;

export const SELECT_BEACON = `${BEACONS}/SELECT_BEACON`;
export const SAVE_BEACON = `${BEACONS}/SAVE_BEACON`;

export const WS_DATA_BEACON = `${WS_DATA}/beacon`;
export const WS_DATA_BEACONS = `${WS_DATA}/beacons`;